"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAnalytics = exports.AnalyticsProvider = void 0;
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var analytics_1 = tslib_1.__importDefault(require("analytics"));
var AnalyticsContext = (0, react_1.createContext)(null);
var AnalyticsProvider = function (_a) {
    var appName = _a.appName, plugins = _a.plugins, children = _a.children;
    var analytics = (0, react_1.useMemo)(function () {
        return (0, analytics_1.default)({
            app: appName,
            plugins: plugins,
        });
    }, [appName, plugins]);
    return (0, jsx_runtime_1.jsx)(AnalyticsContext.Provider, tslib_1.__assign({ value: analytics }, { children: children }));
};
exports.AnalyticsProvider = AnalyticsProvider;
var useAnalytics = function () {
    var context = (0, react_1.useContext)(AnalyticsContext);
    if (context === undefined) {
        throw new Error('useAnalytics must be used within a AnalyticsProvider');
    }
    return context;
};
exports.useAnalytics = useAnalytics;
